export default __webpack_public_path__ + "static/media/single-03-bathroom-active.b809d101.webp";